import {RuleBundleType, RuleOrWorkflowBundleType} from '@frontapp/workflows/rules';
import React, {forwardRef, PropsWithChildren} from 'react';

import {ActivityWithIcon} from './activityWithIcon';

/*
 * Props.
 */

interface ActivityWithRuleIconProps {
  ruleBundleType?: RuleOrWorkflowBundleType;
}

/*
 * Component.
 */

export const ActivityWithRuleIcon = forwardRef<HTMLDivElement, PropsWithChildren<ActivityWithRuleIconProps>>(
  ({ruleBundleType, children}, ref) => (
    <ActivityWithIcon iconName={computeRuleIconName(ruleBundleType)} ref={ref}>
      {children}
    </ActivityWithIcon>
  ),
);

/*
 * Helpers.
 */

export function computeRuleIconName(ruleBundleType?: RuleOrWorkflowBundleType) {
  return ruleBundleType === RuleBundleType.MACRO ? 'lightning' : 'gearActivity';
}
